import buffer from '@turf/buffer';
import { point as turfPoint } from '@turf/helpers';
import { Feature, FeatureCollection, Point, Polygon as GeoJSONPolygon } from 'geojson';
import { create, findList, refreshBacklogPoint, remove, updateLocation, updateProperties } from '../../api/operation/backlogPoint';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';

export default class BacklogPointLoader extends SingletonEventEmitterClass {
  private _data: any[] = [];
  private _editingPoint?: any = undefined;
  private _center?: ILngLat = undefined;

  public get geojson(): FeatureCollection<Point> {
    return {
      type: 'FeatureCollection',
      features: this._data.length ? this._data.map<Feature<Point>>(point => {
        return {
          type: 'Feature',
          geometry: point.lngLat.geometry!,
          properties: {
            id: point._id,
            radius: point.radius,
            warning: point.actualStockNumber > point.warningNumber ? 'redBacklogPoint' : 'grayBacklogPoint',
            info: {
              ...point, layerType: 'backlogPoint',
            },
          },
        };
      }) : [],
    };
  }

  public get geojsonBuffer(): FeatureCollection<GeoJSONPolygon> {
    return {
      type: 'FeatureCollection',
      features: this._data.length ? this._data.map<Feature<GeoJSONPolygon>>(point => {
        const pointGeometry = turfPoint(point.lngLat.geometry.coordinates, { info: { ...point, layerType: 'backlogPoint' }, id: point._id, warningNumber: point.warningNumber }) as Feature<Point>;
        return buffer(pointGeometry, point.radius / 1000, { units: 'kilometers' }) as Feature<GeoJSONPolygon>;
      }) : [],
    };
  }

  public onMapUpdatedCenter(center: ILngLat) {
    this._center = center;
    this._fetchData();
  }

  public async remove(id: string) {
    await remove(id);
    this._data = this._data.filter(item => item._id !== id);
    this._triggerUpdate();
  }

  public async create(name: string, radius: number, warningNumber: number, lngLat: ILngLat) {
    await create(name, radius, warningNumber, lngLat);
    await this._fetchData();
  }

  public async onMapRightClick(id: string) {
    this.remove(id);
  }

  public async update(name: string, radius: number, warningNumber: number, id: string) {
    const { data } = await updateProperties(name, radius, warningNumber, id);
    const modify = this._data.find(item => item._id === data._id);
    modify.name = data.name;
    modify.radius = data.radius;
    modify.warningNumber = data.warningNumber;
  }

  public onMapMouseDown(id: string) {
    const point = this._data.find(row => row._id === id);
    if (point) {
      this._editingPoint = point;
    }
  }

  public onMapMouseMove(lngLat: ILngLat) {
    if (this._editingPoint) {
      this._editingPoint.lngLat.geometry.coordinates = lngLat;
      this._triggerUpdate();
    }
  }

  public onMapMouseUp() {
    if (this._editingPoint) {
      this._updatePointLocation(this._editingPoint._id, this._editingPoint.lngLat.geometry.coordinates);
      this._editingPoint = undefined;
    }
  }

  public async updateBacklogPointStock(center: ILngLat) {
    refreshBacklogPoint(center, 20000);
  }

  public updateGeometryInfo(geometryInfo: any) {
    const backlogPoint = this._data.find(item => item._id === geometryInfo._id);
    return backlogPoint;
  }

  private async _fetchData() {
    const { data } = await findList(this._center as ILngLat, 20000);
    this._data = data.items!;
    this._triggerUpdate();
  }

  private _updatePointLocation(id: string, lngLat: ILngLat) {
    (async () => {
      await updateLocation(id, lngLat);
      this._triggerUpdate();
    })();
  }

  private _triggerUpdate() {
    this.emit('updated');
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/BacklogPointLoader.ts